import type { ApiClient } from "@carepass/api-client";

export interface MoneyMetric { count: number; amount: number }
export interface HistoricalMetrics {
  date: string; cumulativeMembers: number; joinedMembers: number; closedMembers: number; netMembers: number;
  payments: MoneyMetric; cancellations: MoneyMetric; bankRefunds: MoneyMetric;
}
export interface LiveMetrics {
  work: { transactionReviews: number; requestedRefunds: MoneyMetric; benefitReviews: number; receivedInquiries: number };
  balances: Array<{ purpose: string; bankName: string; virtualAccountNumber: string; balanceAmount: number | null; capturedAt: string | null; status: string; message: string | null }>;
  refreshedAt: string;
}
export async function getServiceHistory(client: ApiClient, date: string, signal?: AbortSignal) {
  return (await client.get<HistoricalMetrics>("/api/v1/admin/bo/service-status", { query: { date }, signal })).data;
}
export async function refreshServiceWork(client: ApiClient, signal?: AbortSignal) {
  return (await client.post<LiveMetrics>("/api/v1/admin/bo/service-status/refresh", undefined, { signal })).data;
}
